import * as actionTypes from "./ActionTypes";

export const changeShowDialogsAction = (key, value) => {
  return { type: actionTypes.CHANGE_SHOW_DIALOGS, key, value };
};

export const clearStateAction = (state) => {
  return { type: actionTypes.CLEAR_STATE, state };
};

export const SearchOrgsAction = (data) => {
  return { type: actionTypes.SET_SEARCHED_ORGS, data };
};

export const getOrganizationAction = (data, getAll = false) => {
  return { type: actionTypes.GET_ORGANIZATION, data, getAll };
};
export const getOrganizationSuccessAction = (res, getAll) => {
  return { type: actionTypes.GET_ORGANIZATION_SUCCESS, res, getAll };
};
export const getOrganizationFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_FAIL, error };
};

export const clonePlanAction = (data) => {
  return { type: actionTypes.CLONE_PLAN, data };
};
export const clonePlanSuccessAction = (res) => {
  return { type: actionTypes.CLONE_PLAN_SUCCESS, res };
};
export const clonePlanFailAction = (error) => {
  return { type: actionTypes.CLONE_PLAN_FAIL, error };
};

export const TurnBackPlanAction = (data) => {
  return { type: actionTypes.TURNBACK_PLAN, data };
};
export const TurnBackPlanSuccessAction = (res) => {
  return { type: actionTypes.TURNBACK_PLAN_SUCCESS, res };
};
export const TurnBackPlanFailAction = (error) => {
  return { type: actionTypes.TURNBACK_PLAN_FAIL, error };
};

export const getAllTenantsAction = (data) => {
  return { type: actionTypes.GET_ALL_TENANTS, data };
};
export const getAllTenantsSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_TENANTS_SUCCESS, res };
};
export const getAllTenantsFailAction = (error) => {
  return { type: actionTypes.GET_ALL_TENANTS_FAIL, error };
};

export const addOrgAction = (data) => {
  return { type: actionTypes.ADD_ORGANIZATION, data };
};
export const addOrgSuccessAction = (res) => {
  return { type: actionTypes.ADD_ORGANIZATION_SUCCESS, res };
};
export const addOrgFailAction = (error) => {
  return { type: actionTypes.ADD_ORGANIZATION_FAIL, error };
};

export const addTenantAction = (data) => {
  return { type: actionTypes.ADD_TENANT, data };
};
export const addTenantSuccessAction = (res) => {
  return { type: actionTypes.ADD_TENANT_SUCCESS, res };
};
export const addTenantFailAction = (error) => {
  return { type: actionTypes.ADD_TENANT_FAIL, error };
};

export const editTenantAction = (data) => {
  return { type: actionTypes.EDIT_TENANT, data };
};
export const editTenantSuccessAction = (res) => {
  return { type: actionTypes.EDIT_TENANT_SUCCESS, res };
};
export const editTenantFailAction = (error) => {
  return { type: actionTypes.EDIT_TENANT_FAIL, error };
};

export const editOrgAction = (data) => {
  return { type: actionTypes.EDIT_ORGANIZATION, data };
};
export const editOrgSuccessAction = (res) => {
  return { type: actionTypes.EDIT_ORGANIZATION_SUCCESS, res };
};
export const editOrgFailAction = (error) => {
  return { type: actionTypes.EDIT_ORGANIZATION_FAIL, error };
};

export const getOrgByIdAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATION_BY_ID, data };
};
export const getOrgByIdSuccessAction = (res) => {
  return { type: actionTypes.GET_ORGANIZATION_BY_ID_SUCCESS, res };
};
export const getOrgByIdFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_BY_ID_FAIL, error };
};

export const changeOrgActivationAction = (data) => {
  return { type: actionTypes.CHANGE_ORGANIZATION_ACTIVATION, data };
};
export const changeOrgActivationSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_ORGANIZATION_ACTIVATION_SUCCESS, res };
};
export const changeOrgActivationFailAction = (error) => {
  return { type: actionTypes.CHANGE_ORGANIZATION_ACTIVATION_FAIL, error };
};

export const changeTenantActivationAction = (data) => {
  return { type: actionTypes.CHANGE_TENANT_ACTIVATION, data };
};
export const changeTenantActivationSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_TENANT_ACTIVATION_SUCCESS, res };
};
export const changeTenantActivationFailAction = (error) => {
  return { type: actionTypes.CHANGE_TENANT_ACTIVATION_FAIL, error };
};

export const deleteTenantAction = (data) => {
  return { type: actionTypes.DELETE_TENANT, data };
};
export const deleteTenantSuccessAction = (res) => {
  return { type: actionTypes.DELETE_TENANT_SUCCESS, res };
};
export const deleteTenantFailAction = (error) => {
  return { type: actionTypes.DELETE_TENANT_FAIL, error };
};

export const getTenantByIdAction = (data) => {
  return { type: actionTypes.GET_TENANT_BY_ID, data };
};
export const getTenantByIdSuccessAction = (res) => {
  return { type: actionTypes.GET_TENANT_BY_ID_SUCCESS, res };
};
export const getTenantByIdFailAction = (error) => {
  return { type: actionTypes.GET_TENANT_BY_ID_FAIL, error };
};

export const getOrganizationUserAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATION_USER, data };
};
export const getOrganizationUserSuccessAction = (res) => {
  return { type: actionTypes.GET_ORGANIZATION_USER_SUCCESS, res };
};
export const getOrganizationUserFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_USER_FAIL, error };
};

export const getTenantUserAction = (data) => {
  return { type: actionTypes.GET_TENANT_USER, data };
};
export const getTenantUserSuccessAction = (res) => {
  return { type: actionTypes.GET_TENANT_USER_SUCCESS, res };
};
export const getTenantUserFailAction = (error) => {
  return { type: actionTypes.GET_TENANT_USER_FAIL, error };
};

export const updateOrgUserAction = (data) => {
  return { type: actionTypes.UPDATE_ORGANIZATION_USER, data };
};
export const updateOrgUserSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_ORGANIZATION_USER_SUCCESS, res };
};
export const updateOrgUserFailAction = (error) => {
  return { type: actionTypes.UPDATE_ORGANIZATION_USER_FAIL, error };
};

export const updateTenantUserAction = (data) => {
  return { type: actionTypes.UPDATE_TENANT_USER, data };
};
export const updateTenantUserSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_TENANT_USER_SUCCESS, res };
};
export const updateTenantUserFailAction = (error) => {
  return { type: actionTypes.UPDATE_TENANT_USER_FAIL, error };
};

export const changeOrganizationPasswordAction = (data) => {
  return { type: actionTypes.CHANGE_ORG_PASSWORD, data };
};
export const changeOrganizationPasswordSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_ORG_PASSWORD_SUCCESS, res };
};
export const changeOrganizationPasswordFailAction = (error) => {
  return { type: actionTypes.CHANGE_ORG_PASSWORD_FAIL, error };
};

export const changeTenantPasswordAction = (data) => {
  return { type: actionTypes.CHANGE_TENANT_PASSWORD, data };
};
export const changeTenantPasswordSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_TENANT_PASSWORD_SUCCESS, res };
};
export const changeTenantPasswordFailAction = (error) => {
  return { type: actionTypes.CHANGE_TENANT_PASSWORD_FAIL, error };
};

export const getUserTokenAction = (data) => {
  return { type: actionTypes.GET_USER_TOKEN, data };
};
export const getUserTokenSuccessAction = (res) => {
  return { type: actionTypes.GET_USER_TOKEN_SUCCESS, res };
};
export const getUserTokenFailAction = (error) => {
  return { type: actionTypes.GET_USER_TOKEN_FAIL, error };
};

export const getUserTokenByTenantIdAction = (data) => {
  return { type: actionTypes.GET_USER_TOKEN_BY_TENANT_ID, data };
};

export const getOrganizationUsageAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATION_USAGE, data };
};
export const getOrganizationUsageSuccessAction = (res, interval) => {
  return { type: actionTypes.GET_ORGANIZATION_USAGE_SUCCESS, res, interval };
};
export const getOrganizationUsageFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATION_USAGE_FAIL, error };
};

export const getOrganizationsUsageAction = (data) => {
  return { type: actionTypes.GET_ORGANIZATIONS_USAGE, data };
};
export const getOrganizationsUsageSuccessAction = (res, interval) => {
  return { type: actionTypes.GET_ORGANIZATIONS_USAGE_SUCCESS, res, interval };
};
export const getOrganizationsUsageFailAction = (error) => {
  return { type: actionTypes.GET_ORGANIZATIONS_USAGE_FAIL, error };
};

export const downloadUsageAction = (data) => {
  return { type: actionTypes.DOWNLOAD_USAGE, data };
};
export const downloadUsageSuccessAction = (res) => {
  return { type: actionTypes.DOWNLOAD_USAGE_SUCCESS, res };
};
export const downloadUsageFailAction = (error) => {
  return { type: actionTypes.DOWNLOAD_USAGE_FAIL, error };
};

export const downloadExcelFileAction = (plan) => {
  return { type: actionTypes.DOWNLOAD_EXCEL_FILE, plan };
};
export const downloadExcelFileSuccessAction = (res) => {
  return { type: actionTypes.DOWNLOAD_EXCEL_FILE_SUCCESS, res };
};
export const downloadExcelFileFailAction = (error) => {
  return { type: actionTypes.DOWNLOAD_EXCEL_FILE_FAIL, error };
};

export const downloadOptimizeFileAction = (plan) => {
  return { type: actionTypes.SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE, plan };
};
export const downloadOptimizeFileSuccessAction = (res) => {
  return { type: actionTypes.SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_SUCCESS, res };
};
export const downloadOptimizeFileFailAction = (error) => {
  return { type: actionTypes.SUPERADMIN_DOWNLOAD_OPTIMIZE_FILE_FAIL, error };
};

export const getOrgPOCAction = (data) => {
  return { type: actionTypes.GET_ORG_POC, data };
};
export const getOrgPOCSuccessAction = (res) => {
  return { type: actionTypes.GET_ORG_POC_SUCCESS, res };
};
export const getOrgPOCFailAction = (error) => {
  return { type: actionTypes.GET_ORG_POC_FAIL, error };
};

export const updateOrgPOCAction = (data) => {
  return { type: actionTypes.UPDATE_ORG_POC, data };
};
export const updateOrgPOCSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_ORG_POC_SUCCESS, res };
};
export const updateOrgPOCFailAction = (error) => {
  return { type: actionTypes.UPDATE_ORG_POC_FAIL, error };
};

export const addOrgPOCTypeAction = (data) => {
  return { type: actionTypes.ADD_ORG_POC, data };
};
export const addOrgPOCTypeSuccessAction = (res) => {
  return { type: actionTypes.ADD_ORG_POC_SUCCESS, res };
};
export const addOrgPOCTypeFailAction = (error) => {
  return { type: actionTypes.ADD_ORG_POC_FAIL, error };
};

export const removeOrgPOCTypeAction = (data) => {
  return { type: actionTypes.REMOVE_ORG_POC, data };
};
export const removeOrgPOCTypeSuccessAction = (res) => {
  return { type: actionTypes.REMOVE_ORG_POC_SUCCESS, res };
};
export const removeOrgPOCTypeFailAction = (error) => {
  return { type: actionTypes.REMOVE_ORG_POC_FAIL, error };
};

export const getOrganizationAdminAction = (data) => {
  return { type: actionTypes.GET_ORG_ADMINS, data };
};
export const getOrganizationAdminSuccessAction = (res) => {
  return { type: actionTypes.GET_ORG_ADMINS_SUCCESS, res };
};
export const getOrganizationAdminFailAction = (error) => {
  return { type: actionTypes.GET_ORG_ADMINS_FAIL, error };
};

export const addOrgAdminAction = (data) => {
  return { type: actionTypes.ADD_ORG_ADMIN, data };
};
export const addOrgAdminSuccessAction = (res) => {
  return { type: actionTypes.ADD_ORG_ADMIN_SUCCESS, res };
};
export const addOrgAdminFailAction = (error) => {
  return { type: actionTypes.ADD_ORG_ADMIN_FAIL, error };
};

export const executeManuallyCVRPAction = (data) => {
  return { type: actionTypes.MANUAL_CVRP_LAUNCH_MODE, data };
};
export const executeManuallyCVRPSuccessAction = (res) => {
  return { type: actionTypes.MANUAL_CVRP_LAUNCH_MODE_SUCCESS, res };
};
export const executeManuallyCVRPFailAction = (error) => {
  return { type: actionTypes.MANUAL_CVRP_LAUNCH_MODE_FAIL, error };
};

export const getAllPlansAction = (data) => {
  return { type: actionTypes.GET_ALL_PLANS, data };
};
export const getAllPlansSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_PLANS_SUCCESS, res };
};
export const getAllPlansFailAction = (error) => {
  return { type: actionTypes.GET_ALL_PLANS_FAIL, error };
};

export const setPlanStatusAction = (data) => {
  return { type: actionTypes.SET_PLAN_STATUS, data };
};
export const setPlanStatusSuccessAction = (res) => {
  return { type: actionTypes.SET_PLAN_STATUS_SUCCESS, res };
};
export const setPlanStatusFailAction = (error) => {
  return { type: actionTypes.SET_PLAN_STATUS_FAIL, error };
};

export const restorePlanAction = (data) => {
  return { type: actionTypes.RESTORE_PLAN, data };
};
export const restorePlanSuccessAction = (res) => {
  return { type: actionTypes.RESTORE_PLAN_SUCCESS, res };
};
export const restorePlanFailAction = (error) => {
  return { type: actionTypes.RESTORE_PLAN_FAIL, error };
};

export const setCustomSmsAction = (data) => {
  return { type: actionTypes.SET_CUSTOM_SMS_LIST, data };
};
export const setCustomSmsSuccessAction = (res) => {
  return { type: actionTypes.SET_CUSTOM_SMS_LIST_SUCCESS, res };
};
export const setCustomSmsFailAction = (error) => {
  return { type: actionTypes.SET_CUSTOM_SMS_LIST_FAIL, error };
};

export const getCustomSmsAction = (data) => {
  return { type: actionTypes.GET_CUSTOM_SMS_LIST, data };
};
export const getCustomSmsSuccessAction = (res) => {
  return { type: actionTypes.GET_CUSTOM_SMS_LIST_SUCCESS, res };
};
export const getCustomSmsFailAction = (error) => {
  return { type: actionTypes.GET_CUSTOM_SMS_LIST_FAIL, error };
};

export const getVerificationCodeConfigAction = (data) => {
  return { type: actionTypes.GET_VERIFICATION_CODE_CONFIG, data };
};
export const getVerificationCodeConfigSuccessAction = (res) => {
  return { type: actionTypes.GET_VERIFICATION_CODE_CONFIG_SUCCESS, res };
};
export const getVerificationCodeConfigFailAction = (error) => {
  return { type: actionTypes.GET_VERIFICATION_CODE_CONFIG_FAIL, error };
};

export const setVerificationCodeConfigAction = (data) => {
  return { type: actionTypes.SET_VERIFICATION_CODE_CONFIG, data };
};
export const setVerificationCodeConfigSuccessAction = (res) => {
  return { type: actionTypes.SET_VERIFICATION_CODE_CONFIG_SUCCESS, res };
};
export const setVerificationCodeConfigFailAction = (error) => {
  return { type: actionTypes.SET_VERIFICATION_CODE_CONFIG_FAIL, error };
};

export const getWebHookConfigAction = (data) => {
  return { type: actionTypes.GET_WEBHOOK_CONFIG, data };
};
export const getWebHookConfigSuccessAction = (res) => {
  return { type: actionTypes.GET_WEBHOOK_CONFIG_SUCCESS, res };
};
export const getWebHookConfigFailAction = (error) => {
  return { type: actionTypes.GET_WEBHOOK_CONFIG_FAIL, error };
};

export const setWebhookConfigAction = (data) => {
  return { type: actionTypes.SET_WEBHOOK_CONFIG, data };
};
export const setWebhookConfigSuccessAction = (res) => {
  return { type: actionTypes.SET_WEBHOOK_CONFIG_SUCCESS, res };
};
export const setWebhookConfigFailAction = (error) => {
  return { type: actionTypes.SET_WEBHOOK_CONFIG_FAIL, error };
};

export const getAllTenantUsersAction = (data) => {
  return { type: actionTypes.GET_ALL_TENANT_USERS, data };
};
export const getAllTenantUsersSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_TENANT_USERS_SUCCESS, res };
};
export const getAllTenantUsersFailAction = (error) => {
  return { type: actionTypes.GET_ALL_TENANT_USERS_FAIL, error };
};

export const getAllOrgUsersAction = (data) => {
  return { type: actionTypes.GET_ALL_ORG_USERS, data };
};
export const getAllOrgUsersSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_ORG_USERS_SUCCESS, res };
};
export const getAllOrgUsersFailAction = (error) => {
  return { type: actionTypes.GET_ALL_ORG_USERS_FAIL, error };
};

export const getRoleFlagsAction = (data) => {
  return { type: actionTypes.GET_ROLE_FLAG, data };
};
export const getRoleFlagsSuccessAction = (res) => {
  return { type: actionTypes.GET_ROLE_FLAG_SUCCESS, res };
};
export const getRoleFlagsFailAction = (error) => {
  return { type: actionTypes.GET_ROLE_FLAG_FAIL, error };
};

export const getOrgRoleFlagsAction = (data) => {
  return { type: actionTypes.GET_ORG_ROLE_FLAG, data };
};
export const getOrgRoleFlagsSuccessAction = (res) => {
  return { type: actionTypes.GET_ORG_ROLE_FLAG_SUCCESS, res };
};
export const getOrgRoleFlagsFailAction = (error) => {
  return { type: actionTypes.GET_ORG_ROLE_FLAG_FAIL, error };
};

export const createTenantUserAction = (data) => {
  return { type: actionTypes.CREATE_TENANT_USER, data };
};
export const createTenantUserSuccessAction = (res) => {
  return { type: actionTypes.CREATE_TENANT_USER_SUCCESS, res };
};
export const createTenantUserFailAction = (error) => {
  return { type: actionTypes.CREATE_TENANT_USER_FAIL, error };
};

export const createOrgUserAction = (data) => {
  return { type: actionTypes.CREATE_ORG_USER, data };
};
export const createOrgUserSuccessAction = (res) => {
  return { type: actionTypes.CREATE_ORG_USER_SUCCESS, res };
};
export const createOrgUserFailAction = (error) => {
  return { type: actionTypes.CREATE_ORG_USER_FAIL, error };
};

export const changeUserActivationAction = (data) => {
  return { type: actionTypes.CHANGE_USER_ACTIVATION, data };
};
export const changeUserActivationSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_USER_ACTIVATION_SUCCESS, res };
};
export const changeUserActivationFailAction = (error) => {
  return { type: actionTypes.CHANGE_USER_ACTIVATION_FAIL, error };
};

export const getUserByIdAction = (data) => {
  return { type: actionTypes.GET_USER_BY_ID, data };
};
export const getUserByIdSuccessAction = (res) => {
  return { type: actionTypes.GET_USER_BY_ID_SUCCESS, res };
};
export const getUserByIdFailAction = (error) => {
  return { type: actionTypes.GET_USER_BY_ID_FAIL, error };
};

export const getMissionReasonAction = (data) => {
  return { type: actionTypes.GET_MISSION_REASON, data };
};
export const getMissionReasonSuccessAction = (res) => {
  return { type: actionTypes.GET_MISSION_REASON_SUCCESS, res };
};
export const getMissionReasonFailAction = (error) => {
  return { type: actionTypes.GET_MISSION_REASON_FAIL, error };
};

export const addMissionReasonAction = (data) => {
  return { type: actionTypes.ADD_MISSION_REASON, data };
};
export const addMissionReasonSuccessAction = (res) => {
  return { type: actionTypes.ADD_MISSION_REASON_SUCCESS, res };
};
export const addMissionReasonFailAction = (error) => {
  return { type: actionTypes.ADD_MISSION_REASON_FAIL, error };
};

export const updateMissionReasonAction = (data) => {
  return { type: actionTypes.UPDATE_MISSION_REASON, data };
};
export const updateMissionReasonSuccessAction = (res) => {
  return { type: actionTypes.UPDATE_MISSION_REASON_SUCCESS, res };
};
export const updateMissionReasonFailAction = (error) => {
  return { type: actionTypes.UPDATE_MISSION_REASON_FAIL, error };
};

export const deleteMissionReasonAction = (data) => {
  return { type: actionTypes.DELETE_MISSION_REASON, data };
};
export const deleteMissionReasonSuccessAction = (res) => {
  return { type: actionTypes.DELETE_MISSION_REASON_SUCCESS, res };
};
export const deleteMissionReasonFailAction = (error) => {
  return { type: actionTypes.DELETE_MISSION_REASON_FAIL, error };
};

export const changeUserPasswordAction = (data) => {
  return { type: actionTypes.CHANGE_USER_PASSWORD, data };
};
export const changeUserPasswordSuccessAction = (res) => {
  return { type: actionTypes.CHANGE_USER_PASSWORD_SUCCESS, res };
};
export const changeUserPasswordFailAction = (error) => {
  return { type: actionTypes.CHANGE_USER_PASSWORD_FAIL, error };
};

export const getRoleOrgsAction = () => {
  return { type: actionTypes.Get_ROLE_ORGS };
};
export const getRoleOrgsSuccessAction = (res) => {
  return { type: actionTypes.Get_ROLE_ORGS_SUCCESS, res };
};
export const getRoleOrgsFailAction = (error) => {
  return { type: actionTypes.Get_ROLE_ORGS_FAIL, error };
};

export const getOrgsListIdAction = () => {
  return { type: actionTypes.GET_ORG_LIST_ID };
};
export const getOrgsListIdSuccessAction = (res) => {
  return { type: actionTypes.GET_ORG_LIST_ID_SUCCESS, res };
};
export const getOrgsListIdFailAction = (error) => {
  return { type: actionTypes.GET_ORG_LIST_ID_FAIL, error };
};

export const addRoleAction = (data) => {
  return { type: actionTypes.ADD_ROLE, data };
};
export const addRoleSuccessAction = (res) => {
  return { type: actionTypes.ADD_ROLE_SUCCESS, res };
};
export const addRoleFailAction = (error) => {
  return { type: actionTypes.ADD_ROLE_FAIL, error };
};

export const deleteRoleAction = (item) => {
  return { type: actionTypes.DELETE_ROLE, item };
};
export const deleteRoleSuccessAction = (res) => {
  return { type: actionTypes.DELETE_ROLE_SUCCESS, res };
};
export const deleteRoleFailAction = (error) => {
  return { type: actionTypes.DELETE_ROLE_FAIL, error };
};

export const editRoleAction = (data) => {
  return { type: actionTypes.EDIT_ROLE, data };
};
export const editRoleSuccessAction = (res) => {
  return { type: actionTypes.EDIT_ROLE_SUCCESS, res };
};
export const editRoleFailAction = (error) => {
  return { type: actionTypes.EDIT_ROLE_FAIL, error };
};

export const getAllRolesAction = (data) => {
  return { type: actionTypes.GET_ALL_ROLES, data };
};
export const getAllRolesSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_ROLES_SUCCESS, res };
};
export const getAllRolesFailAction = (error) => {
  return { type: actionTypes.GET_ALL_ROLES_FAIL, error };
};

export const getRoleByIdAction = (id) => {
  return { type: actionTypes.GET_ROLE_BY_ID, id };
};
export const getRoleByIdSuccessAction = (res) => {
  return { type: actionTypes.GET_ROLE_BY_ID_SUCCESS, res };
};
export const getRoleByIdFailAction = (error) => {
  return { type: actionTypes.GET_ROLE_BY_ID_FAIL, error };
};

export const getMenuAction = (data) => {
  return { type: actionTypes.GET_MENU, data };
};
export const getMenuSuccessAction = (res) => {
  return { type: actionTypes.GET_MENU_SUCCESS, res };
};
export const getMenuFailAction = (error) => {
  return { type: actionTypes.GET_MENU_FAIL, error };
};

export const getActionAction = (data) => {
  return { type: actionTypes.GET_ACTION, data };
};
export const getActionSuccessAction = (res) => {
  return { type: actionTypes.GET_ACTION_SUCCESS, res };
};
export const getActionFailAction = (error) => {
  return { type: actionTypes.GET_ACTION_FAIL, error };
};

export const getLogHistoryAction = (data) => {
  return { type: actionTypes.GET_PLAN_LOGS_SUPERADMIN, data };
};
export const getLogHistorySuccessAction = (res) => {
  return { type: actionTypes.GET_PLAN_LOGS_SUPERADMIN_SUCCESS, res };
};
export const getLogHistoryFailAction = (error) => {
  return { type: actionTypes.GET_PLAN_LOGS_SUPERADMIN_FAIL, error };
};

export const RoleModifyAction = (action, data) => {
  return { type: actionTypes.ROLE_MODIFY_ACTIONS, action, data };
};

export const getAllContractsAction = (data) => {
  return { type: actionTypes.GET_ALL_CONTRACTS, data };
};
export const getAllContractsSuccessAction = (res) => {
  return { type: actionTypes.GET_ALL_CONTRACTS_SUCCESS, res };
};
export const getAllContractsFailAction = (error) => {
  return { type: actionTypes.GET_ALL_CONTRACTS_FAIL, error };
};

export const addContractAction = (data) => {
  return { type: actionTypes.ADD_CONTRACT, data };
};
export const addContractSuccessAction = (res) => {
  return { type: actionTypes.ADD_CONTRACT_SUCCESS, res };
};
export const addContractFailAction = (error) => {
  return { type: actionTypes.ADD_CONTRACT_FAIL, error };
};

export const deleteContractAction = (item) => {
  return { type: actionTypes.DELETE_CONTRACT, item };
};
export const deleteContractSuccessAction = (res) => {
  return { type: actionTypes.DELETE_CONTRACT_SUCCESS, res };
};
export const deleteContractFailAction = (error) => {
  return { type: actionTypes.DELETE_CONTRACT_FAIL, error };
};

export const editContractAction = (data) => {
  return { type: actionTypes.EDIT_CONTRACT, data };
};
export const editContractSuccessAction = (res) => {
  return { type: actionTypes.EDIT_CONTRACT_SUCCESS, res };
};
export const editContractFailAction = (error) => {
  return { type: actionTypes.EDIT_CONTRACT_FAIL, error };
};

export const removeReminderAction = (data) => {
  return { type: actionTypes.REMOVE_REMINDER, data };
};
export const removeReminderSuccessAction = (res) => {
  return { type: actionTypes.REMOVE_REMINDER_SUCCESS, res };
};
export const removeReminderFailAction = (error) => {
  return { type: actionTypes.REMOVE_REMINDER_FAIL, error };
};

export const removeOrganizationAccessByContractEndAction = (organizationId) => {
  return {
    type: actionTypes.REMOVE_ORG_ACCESS_BY_CONTRACT_END,
    organizationId,
  };
};
export const removeOrganizationAccessByContractEndSuccessAction = (res) => {
  return {
    type: actionTypes.REMOVE_ORG_ACCESS_BY_CONTRACT_END_SUCCESS,
    res,
  };
};
export const removeOrganizationAccessByContractEndFailAction = (error) => {
  return {
    type: actionTypes.REMOVE_ORG_ACCESS_BY_CONTRACT_END_FAIL,
    error,
  };
};

export const getAccountUsageAction = (data) => {
  return { type: actionTypes.GET_ACCOUNT_USAGE, data };
};
export const getAccountUsageSuccessAction = (res) => {
  return { type: actionTypes.GET_ACCOUNT_USAGE_SUCCESS, res };
};
export const getAccountUsageFailAction = (error) => {
  return { type: actionTypes.GET_ACCOUNT_USAGE_FAIL, error };
};

export const createAppVersionAction = (data) => {
  return { type: actionTypes.CREATE_APP_VERSION, data };
};
export const createAppVersionSuccessAction = (res) => {
  return { type: actionTypes.CREATE_APP_VERSION_SUCCESS, res };
};
export const createAppVersionFailAction = (error) => {
  return { type: actionTypes.CREATE_APP_VERSION_FAIL, error };
};


export const getPlanFlowProcessAction = (data) => {
  return { type: actionTypes.GET_PLAN_FLOW_PROCESS, data };
};
export const getPlanFlowProcessSuccessAction = (res) => {
  return { type: actionTypes.GET_PLAN_FLOW_PROCESS_SUCCESS, res };
};
export const getPlanFlowProcessFailAction = (error) => {
  return { type: actionTypes.GET_PLAN_FLOW_PROCESS_FAIL, error };
};

export const getRabbitMqHealthAction = (data) => {
  return { type: actionTypes.GET_RABBIT_MQ_HEALTH, data };
};
export const getRabbitMqHealthSuccessAction = (res) => {
  return { type: actionTypes.GET_RABBIT_MQ_HEALTH_SUCCESS, res };
};
export const getRabbitMqHealthFailAction = (error) => {
  return { type: actionTypes.GET_RABBIT_MQ_HEALTH_FAIL, error };
};